import SignInLayout from './SignInLayout.container';

export default SignInLayout;
